<template>
  <div class="users">
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-d-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card">
      <!-- row属性:gutter表示栅格间隔 -->
      <el-row :gutter="20">
        <!-- col属性:span表示栅格占据的列数 -->
        <el-col :span="8">
          <el-input v-model="queryInfo.query" :clearable="true" placeholder="请输入内容">
            <!-- 注意这个el-button标签是写在el-input标签内部的子标签 -->
            <!-- 如此它才能绑定input的slot的相关属性值 -->
            <el-button @click="onSearch" slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button @click="showDialog" type="primary">添加用户</el-button>
        </el-col>
      </el-row>
    </el-card>
    <!-- 弹出对话框 -->
    <!-- 新增用户信息对话框  -->
    <el-dialog title="添加用户信息" :visible.sync="adduserdialogVisible" width="50%">
      <!-- 添加如下表单样式 -->
      <el-form ref="addFormRef" :rules="addFormRules" :model="addForm" label-width="80px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="addForm.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="addForm.password"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="addForm.email"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="mobile">
          <el-input v-model="addForm.mobile"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog">取 消</el-button>
        <el-button @click="onAddUserEnter" type="primary">确 定</el-button>
      </span>
    </el-dialog>
    <!--修改用户信息对话框-->
    <el-dialog title="修改用户信息" :visible.sync="updateUserDialogVisible" width="40%" @click="updateDialogClosed">
      <el-form ref="updateFormRef" :rules="addFormRules" :model="updateForm" label-width="80px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="updateForm.username"></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input v-model="updateForm.password" disabled></el-input>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-input v-model="updateForm.email"></el-input>
        </el-form-item>

        <el-form-item label="电话" prop="mobile">
          <el-input v-model="updateForm.mobile"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateUserDialogVisible = false">取 消</el-button>
        <el-button @click="onUpdateUserEnter" type="primary">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 用户列表渲染 -->
    <el-table :data="userList" style="width: 100%">
      <el-table-column label="序号" type="index" width="100px"></el-table-column>
      <el-table-column label="用户名" prop="UserName" width="100px"></el-table-column>
      <el-table-column label="手机" prop="Mobile" width="100px"></el-table-column>
      <el-table-column label="邮箱" prop="Email" width="100px"></el-table-column>
      <el-table-column label="状态" prop="MgState" width="100px">
        <!-- 使用到了作用域插槽 -->
        <template slot-scope="dfdf">
          <!-- 绑定事件函数:userState() -->
          <el-switch v-model="dfdf.row.MgState" active-color="#13ce66" @change="userState(dfdf.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200px">
        <!-- 添加两个按钮:添加/删除 -->
        <template slot-scope="scope">
          <el-button @click="updateUserDialog(scope.row)" type="success" size="mini">添加</el-button>
          <el-button @click="deleteUser(scope.row.id)" type="danger" size="mini">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- 分页效果 -->
    <!-- 注意layoutde 形参顺序会影响页面布局的先后 -->
    <!-- 绑定事件一handleSizeChange:每页显示X条后触发 -->
    <!-- 绑定事件二handleCurrentChange:当前页 -->
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="queryInfo.pagenum" :page-size="queryInfo.pagesize" :page-sizes="[3, 5, 7, 9]"
      layout="total,sizes,prev, pager, next,jumper" :total="total">
    </el-pagination>

  </div>
</template>

<script>
export default {
  name: 'PersonalCenter',
  components: {},
  props: {},
  data () {
    return {
      userList: [],
      queryInfo: { query: 'zs3', pagenum: 1, pagesize: 3 },
      total: 0, // 总条数
      adduserdialogVisible: false, // 控制添加用户信息对话框的显示与隐藏
      updateUserDialogVisible: false, // 控制修改用户信息对话框的显示与隐藏

      /* 校验添加用户的表单 */
      addForm: {
        username: '',
        password: '',
        email: '',
        mobile: ''
      },
      addFormRules: {
        username: [
          // required 必填
          // message 信息提示
          // trigger 鼠标失去焦点时触发
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 10, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 15, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          // { validator: checkEmail, trigger: 'blur' },
          {
            pattern: /^[\w.-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/,
            message: '输入正确的邮箱规则',
            trigger: 'blur'
          }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          // { validator: checkMobile, trigger: 'blur' }
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '请输入正确手机号',
            trigger: 'blur'
          }
        ]
      },
      /* 校验修改用户的表单 */
      updateForm: {
        id: '',
        username: '',
        password: '',
        email: '',
        mobile: ''
      }
      // updateFormRules:不用另写,直接用addFormRules即可
    }
  },
  watch: {},
  computed: {},
  methods: {
    // 获取用户列表数据
    async getUserList () {
      const res = await this.$http.get(`${this.$BASE_URL}/api/users`, {
        params: this.queryInfo
      })
      // console.log('thisuserlist', res.data)
      this.userList = res.data.data
      this.total = res.data.total
    },
    // 函数:改变用户状态,形参:userinfo
    async userState (userinfo) {
      // console.log('userinfo:', userinfo)// 有数据,输出了
      const res = await this.$http(`${this.$BASE_URL}/api/userupdate`, {
        method: 'put',
        params: userinfo
      })
      // console.log('res', res.data)
      if (res.data.code !== 200) {
        this.$message.error('更新状态失败!')
        // 回滚数据
        userinfo.MgState = !userinfo.MgState
      } else {
        this.$message.success('更新状态成功!')
      }
    },
    // 每页显示条数改变
    handleSizeChange (newsize) {
      this.queryInfo.pagesize = newsize// 每页显示条数改变，重新获取数据
      this.getUserList()// 重新获取数据
    },
    // 当前页码改变
    handleCurrentChange (newpage) {
      this.queryInfo.pagenum = newpage// 当前页码改变，重新获取数据
      this.getUserList()// 重新获取数据
    },
    // 搜索用户列表
    async onSearch () {
      const res = await this.$http.get(`${this.$BASE_URL}/api/search`, { params: this.queryInfo })
      this.userList = res.data.data
      // this.total = res.data.total
      // console.log('res', res)
    },
    // 点击"添加用户":弹出对话框
    showDialog () {
      this.adduserdialogVisible = !this.adduserdialogVisible
    },
    // 点击添加用户信息的对话框的"确定",提交表单
    onAddUserEnter () {
      // 提交前预校验
      this.$refs.addFormRef.validate(async valid => {
        if (valid) { // 校验通过，提交表单数据到后端API
          try {
            // 提交表单数据到后端API
            const res = await this.$http.post(`${this.$BASE_URL}/api/addusers`, this.addForm)
            if (res.data.code !== 200) { // 添加失败
              this.$message.error(`添加失败: ${res.data.message || '未知错误'}`)
            } else { // 添加成功
              this.$message.success('添加用户成功!')
              this.userList.unshift(res.data.data)// 把新添加的用户放到列表首位
              this.total++// 总条数加1
              this.$refs.addFormRef.resetFields()// 重置表单数据
              this.adduserdialogVisible = false// 关闭对话框
            }
          } catch (error) { // 捕获异常信息
            console.error('API错误:', error)
            this.$message.error(`请求异常: ${error.response?.data?.message || error.message}`)
          }
        }
      })
    },
    // 点击"添加":弹出修改用户信息的对话框
    updateUserDialog (userinfo) {
      this.updateUserDialogVisible = true// 弹出对话框
      this.updateForm = userinfo// 把当前用户信息赋值给修改表单:用于回显数据
    },
    // 点击"删除":删除用户信息
    async deleteUser (id) {
      try {
        // 确认对话框
        await this.$confirm('确定要删除该用户吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        // 调用删除接口
        const res = await this.$http.delete(`${this.$BASE_URL}/api/deleteusers`, {
          params: { id }
        })

        if (res.data.code === 200) {
          this.$message.success('删除用户成功')
          // 重新获取用户列表
          await this.getUserList()
        } else {
          this.$message.error('删除用户失败: ' + res.data.message)
        }
      } catch (error) {
        if (error !== 'cancel') { // 如果不是用户取消操作
          console.error('删除用户错误:', error)
          this.$message.error('删除用户失败: ' + (error.response?.data?.message || error.message))
        }
      }
    },
    // 点击关闭修改用户信息的对话框
    updateDialogClosed () {
      this.$refs.updateFormRef.resetFields()// 重置表单数据
    },
    // 点击"确定":实现用户信息的修改,实现表单数据的校验,提交修改的用户信息到后端API
    onUpdateUserEnter () {
      console.log('确定修改按钮')
      // 此处使用到了父子组件通信:refs传参,详见<el-form ref="updateFormRef"...> </el-form>
      this.$refs.updateFormRef.validate(async (valid) => {
        console.log(' 修改的valid校验 valid', valid)
        this.updateForm.pagenum = this.queryInfo.pagenum
        this.updateForm.pagesize = this.queryInfo.pagesize
        const res = await this.$http.put(`${this.$BASE_URL}/api/updateusers`, this.updateForm)
        console.log('res修改成功返回主页数据', res)
        this.userList = res.data.data
        this.total = res.data.total
        this.updateUserDialogVisible = false
      })
    }
  },
  created () {
    this.getUserList()
  },
  mounted () { }
}
</script>
<style lang="scss" scoped>
/**面包屑**/
.el-breadcrumb {
  font-size: 12px;
}

/**卡片**/
.el-card {
  margin-top: 15px;
  height: 100px;
  box-shadow: 0 1px 1px #353333;
}
</style>
